import { LessonCourseDefaultThumbnail } from '@/constant/imgImport';
import { Avatar } from 'design-system/components/Avatar';
import { Typography } from 'design-system/components/Typography';
import Link from 'next/link';
import { ComponentPropsWithoutRef } from 'react';

type CourseInfoProps = ComponentPropsWithoutRef<'div'> & {
  title: string;
  authorName: string;
  avatar: string;
  groupId: string;
  groupName: string;
  thumbnail: string;
  linkAuthor: string;
  academicRank: string | null;
};

const CourseInfo = (props: CourseInfoProps) => {
  const {
    title,
    groupId,
    groupName,
    thumbnail,
    authorName,
    avatar,
    linkAuthor,
    academicRank,
  } = props;

  return (
    <div className="mb-6 w-full">
      <Typography variant="display2" className="mb-4">
        {title}
      </Typography>
      <div className="mb-4 flex items-center gap-2">
        <Link href={linkAuthor}>
          <Avatar
            type="image"
            src={avatar}
            size={24}
            className="cursor-pointer"
          />
        </Link>
        <div>
          <Typography
            variant="input-label"
            className="text-Text/LightBackground/Secondary"
          >
            Được tạo bởi:
          </Typography>
          <Typography variant="body3" className="line-clamp-2">
            <Link href={linkAuthor}>
              <a className="hover:underline">
                {academicRank && `${academicRank}. `}
                {authorName}
              </a>
            </Link>
            {groupId && (
              <>
                {' '}
                <span className="text-[12px] text-Text/LightBackground/Secondary">
                  trong nhóm{' '}
                </span>
                <Link href={`/my-groups/${groupId}`}>
                  <a className="hover:underline">{groupName}</a>
                </Link>
              </>
            )}
          </Typography>
        </div>
      </div>
      <div className="-ml-4 aspect-video w-[calc(100%+32px)] md:ml-0 md:w-full">
        <img
          src={thumbnail || LessonCourseDefaultThumbnail}
          alt="course thumbnail"
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  );
};

export default CourseInfo;
